/* eslint-disable jsx-a11y/label-has-for,react/no-danger,max-len */
import React, { Component } from 'react';
import Modal from 'react-modal';
import PropTypes from 'prop-types';
import CloseIcon from '../../themes/svg/closeIcon';
import ContainerSummary from './ContainerSummaryConnector';
import { formatPrice } from '../../helpers/formatNumbers';

Modal.setAppElement('#estimateBuilderRoot');


class EstimateSummaryModal extends Component {
  discountTotal = () => this.props.retail - this.props.subtotal;

  promoMessage = () => {
    let text = `${this.props.locale.promoCodeText.replace('{{promoCode}}', this.props.promoCode)}`;
    if (this.props.promoEndDate) {
      text += ` ${this.props.locale.promoEndDateText.replace('{{promoEndDate}}', this.props.promoEndDate)}`;
    }
    return text;
  };

  render = () => (
    <div>
      <Modal
        isOpen={this.props.isOpen}
        className="estimatebuilder-modal"
        onRequestClose={this.props.toggleModal}
        overlayClassName="estimatebuilder-modal-overlay"
        style={{
          content: {
            width: 450,
          },
        }}
      >
        <h2>
          <span className="truncateText">
            {this.props.name} {this.props.locale.summaryHeader}
          </span>
          <span className="modal-close" onClick={this.props.toggleModal} tabIndex="-1" role="button">
            <CloseIcon />
          </span>
        </h2>
        <div className="modal-body">
          <div className="estimateSummary">
            <div className="pricingDetails">
              <div className="summaryTotals">
                <div className="lineItems">
                  {this.props.containerIds.map(id => <ContainerSummary containerId={id} key={id} />)}
                </div>
                <div className="shipping">
                  <label>{this.props.locale.shipping}</label>
                  <span>{this.props.locale.shippingFree}</span>
                </div>
                {this.discountTotal() > 0 && (
                  <div className="youllSave">
                    <label>{this.props.locale.youllSave}</label>
                    <span>{formatPrice(this.discountTotal())}</span>
                  </div>
                )}
                <div className="subTotal">
                  <label>{this.props.locale.pretaxTotal}</label>
                  <span>{formatPrice(this.props.subtotal)}</span>
                </div>
              </div>
              {this.props.promoCode && (
                <div className="promo-message">
                  <span dangerouslySetInnerHTML={{ __html: this.promoMessage() }} />
                </div>
              )}
              {this.props.isAvailableForMandi && (
                <div className="mandi-message">
                  <span>{this.props.locale.mandiText}</span>
                </div>
              )}
            </div>
          </div>
        </div>
      </Modal>
    </div>
  );
}

EstimateSummaryModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  toggleModal: PropTypes.func.isRequired,
  name: PropTypes.string.isRequired,
  subtotal: PropTypes.number,
  retail: PropTypes.number.isRequired,
  promoCode: PropTypes.string,
  promoEndDate: PropTypes.string,
  containerIds: PropTypes.arrayOf(PropTypes.string).isRequired,
  isAvailableForMandi: PropTypes.bool.isRequired,
  locale: PropTypes.shape({
    summaryHeader: PropTypes.string.isRequired,
    shipping: PropTypes.string.isRequired,
    shippingFree: PropTypes.string.isRequired,
    pretaxTotal: PropTypes.string.isRequired,
    youllSave: PropTypes.string.isRequired,
    mandiButtonText: PropTypes.string.isRequired,
    mandiButtonTextMobile: PropTypes.string.isRequired,
    mandiText: PropTypes.string.isRequired,
    promoCodeText: PropTypes.string.isRequired,
    promoEndDateText: PropTypes.string.isRequired,
  }).isRequired,
};

EstimateSummaryModal.defaultProps = {
  subtotal: 0,
  promoCode: null,
  promoEndDate: null,
};

export default EstimateSummaryModal;
